const removeAuthToken = (url = '') =>
  url
    .replace(/([?&])authToken=[^&#]*/g, '$1')
    .replace('?&', '?')
    .replace(/[?&](#|$)/, '$1');

export const authResourceUrl = (url = '', authToken) => {
  const cleanUrl = removeAuthToken(url);
  if (process.env.NODE_ENV !== 'development' || !authToken) {
    return cleanUrl;
  }

  const separator = cleanUrl.includes('?') ? '&' : '?';
  return `${cleanUrl}${separator}authToken=${encodeURIComponent(authToken)}`;
};
